/**
 * Copyright (c) HashiCorp, Inc.
 * SPDX-License-Identifier: MPL-2.0
 */

import type { Products } from '@hashicorp/platform-product-meta'
import Badge from '@hashicorp/react-hds/src/components/badge'
import { IconDot16 } from '@hashicorp/flight-icons/svg-react/dot-16'
import s from './style.module.css'

export interface ProductBadgeProps {
	productName: Products
	hasDot?: boolean
}

const ProductBadge = ({ productName, hasDot }: ProductBadgeProps) => {
	const finalProductName = productName.replace('hashicorp', 'HashiCorp')

	const productBrand =
		finalProductName === 'HashiCorp cloud platform' ? 'hashicorp' : productName

	return (
		<Badge
			className={s.badge}
			text={finalProductName}
			icon={
				hasDot ? (
					<IconDot16
						width="100%"
						height="100%"
						style={{
							display: 'block',
							color: `var(--token-color-${productBrand}-brand)`,
						}}
					/>
				) : undefined
			}
		/>
	)
}

export default ProductBadge
